import * as React from 'react';

import {
	Wrapper,
	LabelWrapper,
	ProgressLabel,
	Label,
	ButtonCancel,
	Bar,
} from './styles';
import { ResourceSelectorTheme } from '../index';
import { FileError } from '../../../containers/ImportManager/actions';
import Utils from '../../../utils';

interface ProgressBarProps {
	percentage: number;
	error: FileError | null;
	theme?: ResourceSelectorTheme;
	isProcessing?: boolean;
	processingLabel?: string;
	hasCancelButton?: boolean;
	onCancel?: () => void;
}

const getLabel = (
	percentage: number,
	error: FileError | null,
	isProcessing?: boolean,
	processingLabel?: string,
	theme?: ResourceSelectorTheme,
) => {
	if (error) {
		return (
			<Label
				value={`error.${error}`}
				isError={true}
				theme={theme}
			/>
		);
	} else if (isProcessing) {
		return processingLabel && (
			<Label
				value={processingLabel}
				theme={theme}
			/>);
	}
	return <ProgressLabel theme={theme}>{percentage}%</ProgressLabel>;
};

const ProgressBar = ({
	percentage,
	error,
	theme = ResourceSelectorTheme.LIGHT,
	isProcessing,
	processingLabel,
	hasCancelButton,
	onCancel,
}: ProgressBarProps) => (
	<Wrapper>
		<LabelWrapper>
			{getLabel(percentage, error, isProcessing, processingLabel, theme)}
			{hasCancelButton && !isProcessing &&
				<ButtonCancel
					type="button"
					isError={!!error}
					theme={theme}
					onClick={onCancel}
				>
					{Utils.getSvgIcon('iconset_close-2')}
				</ButtonCancel>
			}
		</LabelWrapper>
		<Bar
			isError={!!error}
			percentage={percentage}
		/>
	</Wrapper>
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/ProgressBar/index.tsx